import { createAction } from '@reduxjs/toolkit';

export const updateUser = createAction('user/update');
export const logoutUser = createAction('user/logout');
export const isRefresh = createAction('user/isRefresh');

export const updateSubscription = createAction('subscription/update');
export const updateSubscriptions = createAction('subscriptions/update');